module.exports = __webpack_public_path__ + "img/P150T_weapon_132.e1b59703.png";